<template>
  <el-dialog
    custom-class="import-dialog"
    title="选择拼团商品"
    :visible="visible"
    width="1200px"
    @close="close"
  >
    <div class="flex filter-wrapper">
      <div class="flex-1 mr10 w50">
        <div class="panel flex item-center  flex-end">
          <div class="form-wrapper flex flex-wrap">
            <el-select
              class="mr10"
              size="small"
              v-model="gameType"
              placeholder="请选择活动类型"
            >
              <el-option
                :label="v.gameName"
                :value="v.gameCode"
                :key="i"
                v-for="(v, i) in gameTypeList"
              ></el-option>
            </el-select>
            <el-input
              clearable
              style="width:250px"
              v-model.trim="keyword"
              placeholder="请输入活动名称/编号"
              size="small"
              class="ipt mr10"
            ></el-input>
            <el-button type="primary" size="small" @click="search"
              >查询</el-button
            >
          </div>
        </div>
        <div class="table">
          <div class="tips">
            只显示上线活动，点击活动即可查询商品
          </div>
          <div class="send-table">
            <el-table
              :data="records"
              stripe
              border
              ref="brandTable"
              @current-change="handleCurrentChange"
              highlight-current-row
              style="width: 100%"
              id="table"
              size="small"
            >
              <!-- <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          width="50"
          :index="index => index + (currentPage - 1) * pageSize + 1"
              ></el-table-column>-->
              <el-table-column
                header-align="center"
                align="center"
                label="活动编号"
                width="180"
                prop="gameCode"
              >
                <template slot-scope="scope">
                  <div class="table-status flex item-center">
                    <span
                      class="status success-bg"
                      v-show="scope.row.dateFlag == '2'"
                    ></span>
                    <span
                      class="status gray-bg"
                      v-show="scope.row.dateFlag == '1'"
                    ></span>
                    <span
                      class="status danger-bg"
                      v-show="scope.row.dateFlag == '3'"
                    ></span>
                    <span class="flex flex-1 flex-center">{{
                      scope.row.gameCode
                    }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="gameName"
                label="活动名称"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="createTime"
                label="活动创建时间"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="enabledState"
                label="活动状态"
              >
                <template slot-scope="scope">
                  <span
                    class="success"
                    v-show="scope.row.enabledState === 'yes'"
                    >上线</span
                  >
                  <span class="danger" v-show="scope.row.enabledState === 'no'"
                    >下线</span
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="hm-pagination mb20">
          <el-pagination
            background
            :total="total"
            @current-change="paging"
            @size-change="handleSizeChange"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="currentPage"
          ></el-pagination>
        </div>
      </div>
      <div class="filter-result flex-1 w50" v-if="detailsList.length">
        <div class="title bold mb20">选择商品</div>
        <el-table @selection-change="getChecked" border :data="detailsList">
          <el-table-column type="selection"></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            type="index"
            label="序号"
            width="50"
            :index="index => index + (currentPage - 1) * pageSize + 1"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="spuName"
            label="商品名"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop=""
            label="商品图"
          >
            <template slot-scope="scope">
              <div class="img-wrapper">
                <img :src="scope.row.spuMainPic" alt="" />
              </div>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="openteamNumber"
            label="成团数"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="jointeamProfitPrice"
            label="拼团价"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="retailPrice"
            label="原价"
          ></el-table-column>
        </el-table>
      </div>
    </div>
    <div class="btn-wrapper mb20 flex flex-center">
      <el-button size="small" type="primary" @click="save">确 定</el-button>
      <el-button size="small" @click="close">取 消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import { mapState } from "vuex";
import { arrayUnique2 } from "@/utils/utils";
export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(["myActivityList"])
  },
  components: {},
  data() {
    return {
      gameType: "bargains_team",
      pageSize: 10,
      currentPage: 1,
      keyword: "",
      checkedRow: [],
      currentRow: {},
      detailsList: [],
      gameTypeList: [],
      records: [],
      total: 0
    };
  },
  watch: {},
  created() {},
  mounted() {
    this.queryList();
    this.queryGameTypeList();
  },
  methods: {
    async queryGameTypeList() {
      const { result } = await this.$store.dispatch("queryGameTypeList");
      this.gameTypeList = result.filter(v => v.gameCode.indexOf("_team") > -1);
    },
    save() {
      if (!this.checkedRow.length) {
        this.$message({
          type: "warning",
          message: "请先选择拼团商品"
        });
      } else {
        this.$emit("saveGroupon", this.checkedRow);
      }
    },
    handleCurrentChange(row) {
      this.currentRow = row;
      if (row) {
        this.queryChildren(row.gameId);
      }
    },
    close() {
      this.$emit("close");
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    async queryChildren(gameId) {
      const { result } = await this.$store.dispatch("queryMyActivityDetails", {
        gameId
      });
      this.detailsList.push(...result);
      this.detailsList = arrayUnique2(this.detailsList, "goodsRuleId");
    },
    async queryList() {
      const { result } = await this.$store.dispatch("filterMyActivityList", {
        dateFlag: "0",
        enabledState: "yes",
        gameType: this.gameType,
        keyword: this.keyword,
        pageSize: 10,
        pageNo: this.currentPage
      });
      const { pageList } = result;
      const { records, total } = pageList;
      this.records = records;
      this.total = total;
    },
    getChecked(selection) {
      this.checkedRow = selection;
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    }
  }
};
</script>
<style lang="scss" scoped>
.btn {
  cursor: pointer;
  font-size: 0.875rem;
  color: #999;
  padding: 8px 20px;
  transition: background 0.1s linear;
}

.btn.active {
  background: #e50065;
  color: #fff;
  border-radius: 5px;
}

.table-panel {
  margin: 20px 0;
}

.filter-wrapper {
  padding: 20px;
}
.btn-wrapper {
  padding-bottom: 20px;
}

.filter-result {
  width: 300px;
  .title {
    font-size: 16px;
  }
}

.w50 {
  width: 50%;
}

.tips {
  color: #999;
  font-size: 12px;
  line-height: 40px;
}

.img-wrapper {
  img {
    width: 100%;
  }
}
</style>
